import { ExternalCardResult, Typenames } from '@varo/graphql-schema-types';
import { useGlobalSearchParams } from 'expo-router';
import { logGenericErrorEvents } from 'features/moveMoney/screens/dcf/tabapay/helpers/TabaPay.helpers';
import FetchExternalCardDetails from 'services/graphql/queries/FetchExternalCardDetails';
import { useAnalyticsConfiguration } from 'shared/hooks/analytics/useAnalyticsConfiguration';
import { useFormattedCombinedError } from 'shared/hooks/errorFormatters/useFormattedCombinedError/useFormattedCombinedError';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

const useExternalCardDetails = () => {
  const { cardId } = useGlobalSearchParams<{
    cardId: string;
  }>();
  const { segmentClient } = useAnalyticsConfiguration();
  const [result, reExecuteQuery] = useQuery<{
    externalCard: ExternalCardResult;
  }>({
    query: FetchExternalCardDetails,
    variables: { cardId },
    requestPolicy: 'network-only',
  });
  const { data, fetching, error, stale: refreshing } = result;

  const responseError = useFormattedCombinedError(error);

  let errorModel = responseError
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: responseError.title,
        messageBody: responseError.message,
        primaryButton: undefined,
        secondaryButton: undefined,
        is3DSError: false,
        analytics: undefined,
      }
    : null;

  if (data?.externalCard?.__typename === Typenames.ExternalCardError) {
    errorModel = {
      screenType: ErrorScreenType.Error,
      messageHeadline: data.externalCard.title,
      messageBody: data.externalCard.message,
      primaryButton: undefined,
      secondaryButton: undefined,
      is3DSError: false,
      analytics: undefined,
    };
    logGenericErrorEvents(
      'External Card Details',
      'Generic_Error',
      segmentClient,
      data.externalCard.code,
      data.externalCard.message,
    );
  }

  const externalCardDetails =
    data?.externalCard?.__typename === Typenames.ExternalCardSuccess
      ? data.externalCard.externalCard
      : null;

  return {
    errorModel,
    fetching,
    error,
    externalCardDetails,
    reExecuteQuery,
    refreshing,
  };
};

export default useExternalCardDetails;
